<template>
  <div class="delinquency-notice">
    <div class="background" />
    <div class="main">
      <p class="hold" @click="close">⚠️Your account is on hold⚠️</p>
      <p>There was a payment problem on your recent order:</p>
      <p class="has-text-weight-bold" style="padding: 12px 0">
        {{ delinquencyNotice }}
      </p>
      <p>
        Please contact us to remedy this issue or if you have any questions.
      </p>
      <p class="buttons" style="margin: 16px 0">
        <span class="button is-capitalized is-medium pulse" @click="contactChatSupport"><i
            class="far fa-comment" />&nbsp;Live Chat</span>
        <span class="button is-capitalized is-medium pulse" @click="emailAboutPayment"><i
            class="far fa-envelope" />&nbsp;Email</span>
        <span class="button is-medium" @click="restart">Restart</span>
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: "DelinquencyNotice",
  data() {
    return {
      messagingApp: null,
      phoneNumber: null,
      apps: ["whatsapp", "telegram", "line"],
    };
  },
  computed: {
    // Dec 31: Burrito Squad #501 (450 baht)
    delinquencyNotice() {
      return this.$store.state.user.data.delinquency_notice;
    },
    phone() {
      return this.$store.getters.phoneNumber;
    },
  },
  mounted() {
    var flashDeal = `DELINQUENT ${this.phone} @ ${this.delinquencyNotice}`;
    this.sendSuperuserNotification(flashDeal);
  },
  methods: {
    close() {
      if (!this.isSuperUser()) return;
      this.$emit("close");
    },
    restart() {
      location.reload();
    },
    contactChatSupport() {
      this.successToast("Opening TUK Messenger Chat...", "top");
      this.contactFBMessengerSupport();
    },
    emailAboutPayment() {
      var email = "bizdev@tukapp.co";
      var subject = `Account Hold ${this.phone}: ${this.delinquencyNotice}`;
      window.location.href = `mailto:${email}?subject=${subject}`;
    },
  },
};
</script>

<style scoped>
.delinquency-notice {
  position: relative;
  z-index: 999999;
}

.background {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
}

.main {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 20px;
  /* padding-bottom: 40px; */
  /* border: 6px solid yellow; */
  background-color: rgb(255, 255, 100);
  text-align: left;
}

.hold {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 1.2em;
}

.pulse {
  animation: shadow-pulse 2s ease-out infinite;
  border-radius: 3px;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: inset 0 0 0 0px rgba(255, 0, 0, 1);
  }

  50% {
    box-shadow: inset 0 0 0 6px rgba(255, 0, 0, 0.7);
  }

  100% {
    box-shadow: inset 0 0 0 0px rgba(255, 0, 0, 1);
  }
}
</style>